import React, { useState, useReducer, useEffect } from "react";
import Typography from "../../Typography";
import { Box, Grid, useTheme, useMediaQuery } from "@mui/material";
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


import TooltipIndicators from "../../Dash/Tooltip";
import { renderActiveShape } from "../../Dash/NewDash/shapes";
import defaultReducer from "../../../utils/defaultReducer";
import api from "../../../api";
import { getSession } from "../../../auth";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
  ReferenceLine,
  Text,
  
} from "recharts";

import "./styles.css";

const enterprise = getSession()?.profile.enterprise;


function createData(
  name,
  calories,
  fat,
  carbs,
  protein,
) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];


const loadChartComponent = ({ active, payload }) => {
  return null;
};


const GroupsAndConversationsCount = (props) => {
  return (
    <Grid container spacing={2} id="dash-grid">
      <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
        <Box id="small-frame" fullWidth>
          <Box className="dash-centralizer">
            <Box id="dash-box-1">
              <Box className="fontSize-title">
                <Typography
                  align="center"
                  text="Grupos"
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              <Box className="dash-values" id="color-blue">
                {props.groups || 0}
              </Box>
            </Box>
          </Box>
          <TooltipIndicators text="Total de grupos com troca de mensagens no dia." />
        </Box>
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
        <Box id="small-frame" fullWidth>
          <Box className="dash-centralizer">
            <Box id="dash-box-1">
              <Box className="fontSize-title">
                <Typography
                  align="center"
                  text="Conversas"
                  color="darkGray"
                  fontWeight="500"
                  variant="subtitle1"
                />
              </Box>
              <Box className="dash-values" id="color-blue">
                {props.conversations || 0}
              </Box>
            </Box>
          </Box>
          <TooltipIndicators text="Total de conversas com troca de mensagens no dia." />
        </Box>
      </Grid>
    </Grid>
  );
};

const MessagesChart = (props) => {
  const [state, setState] = useReducer(defaultReducer, {
    activeIndex: 0,
  })

  // Calculate total value from messagesData
  const total = Array.isArray(props.messagesData)
    ? props.messagesData.reduce((sum, entry) => sum + (entry.value || 0), 0)
    : 0;
    

  return (
    <Grid container spacing={1} id="dash-grid" key={"scout-graph-1"}>
      <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
        <Box id="big-frame-2" fullWidth>
          <Box className="tooltip-centralizer">
            <TooltipIndicators text="Total de mensagens trocadas pelos números Scout." />
          </Box>
          <Box className="fontSize-title">
            <Typography
              align="center"
              text="Mensagens"
              color="darkGray"
              fontWeight="500"
              variant="subtitle1"
            />
          </Box>
          <Box>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  activeIndex={state.activeIndex}
                  activeShape={renderActiveShape}
                  data={props.messagesData}
                  cx="50%"
                  cy="50%"
                  innerRadius="37%"
                  outerRadius="47%"
                  fill="#8884d8"
                  dataKey="value"
                  onMouseEnter={(_, index) =>
                    setState({ activeIndex: index })
                  }
                >
                  {props.messagesData !== undefined && props.messagesData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={props.messagesColors[index % props.messagesColors.length]} />
                  ))}
                </Pie>
                <Tooltip offset={-50} content={loadChartComponent} />
              </PieChart>
            </ResponsiveContainer>
            {/* Label below the chart showing the total */}
            <Box className="fontSize-title" sx={{ mt: -2 }}>
              <Typography
                align="center"
                fontWeight="400"
                color="darkGray"
                variant="subtitle1"
                text={`Total: ${total}`}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
const SentimentSlider = (props) => {

  const score = props.sentiment ? props.sentiment * 10 : 0; 

  return (
    <Grid container spacing={1} id="dash-grid" key={"scout-graph-1"}>
      <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
        <Box id="big-frame-2" fullWidth>
          <Box className="tooltip-centralizer">
            <TooltipIndicators text="Nota de satisfação média das conversas." />
          </Box>
          <Box className="fontSize-title">
            <Typography
              align="center"
              text="Índice de Satisfação"	
              color="darkGray"
              fontWeight="500"
              variant="subtitle1"
            />
          </Box>

          <Box sx={{ mt: 2 }}>
            <Stack sx={{ height: '20vh', minHeight: '250px' }} spacing={1} direction="row">

              <Slider
                getAriaLabel={() => 'Satisfação'}
                orientation="vertical"
                valueLabelFormat={(v) => `${(v / 10).toFixed(1)}`}
                value={score}
                valueLabelDisplay="on"
                disabled
                marks={[
                  {
                    value: 0,
                    label: '0 - Muito negativa',
                  },
                  {
                    value: 50,
                    label: '5 - Neutra',
                  },
                  {
                    value: 100,
                    label: '10 - Muito positiva',
                  },
                ]}
              />
            </Stack>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const ProductsChart = (props) => {
  return (
          <Grid container spacing={2} id="dash-grid" key={"scout-graph-1"}>
            <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
              <Box id="big-frame-2" fullWidth>
                <Box className="tooltip-centralizer">
                  <TooltipIndicators text="Notas de satisfação da análise de sentimento das converas." />
                </Box>
                <Box className="fontSize-title">
                  <Typography
                    align="center"
                    text="Produtos e Serviços"	
                    color="darkGray"
                    fontWeight="500"
                    variant="subtitle1"
                  />
                </Box>
                <Box 
                  sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'top', 
                    height: '100%',
                    minHeight: '350px',
                    mt: 2
                  }}
                >
                  <BarChart
                    width={400}
                    height={300}
                    data={props.productsCount !== undefined ? props.productsCount : []}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 35,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <Tooltip />
                    <Legend />

                    {props.productsList !== undefined && props.productsList.map((sa) => (
                      <Bar key={sa.dataKey} dataKey={sa.dataKey} fill={sa.fill} />
                    ))}
                  </BarChart>
                </Box>
              </Box>
            </Grid>
          </Grid>
  );
};

const SummariesTable = (props) => {

  const setActiveChat = async (id) => {
    const res = await api.get(
      `api/enterprises/${enterprise.id}/scout_accounts/${props.accountId}/conversation/${id}/`
    );
    if (res.status == 200) {
        const activeChat = { account_id: props.accountId, ...res.data[0] };
        props.setParent({
            activeChat: activeChat,
            showSearch: false,
            showCRMSidebar: false,
            showAnalyticsSidebar: true,
        });
      }
  };


  return (
    <Grid container spacing={1} id="dash-grid" key={"scout-graph-1"}>
      <Grid item lg={12} md={12} sm={12} xs={12} id="grid-item">
        <Box id="big-frame-2" fullWidth>
          <Box className="tooltip-centralizer">
            <TooltipIndicators text="Resumos das conversas." />
          </Box>
          <Box className="fontSize-title">
            <Typography
              align="center"
              text="Resumos"
              color="darkGray"
              fontWeight="500"
              variant="subtitle1"
            />
          </Box>
          <Box>

    <TableContainer component={Paper} sx={{ maxHeight: '28vh', overflowY: 'auto' }}>
      <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Conversa</TableCell>
            <TableCell >Resumo</TableCell>
            <TableCell >Sentimento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.summaries.map((row) => (
            <TableRow
              key={row.name}
              sx={{ 
                '&:last-child td, &:last-child th': { border: 0 },
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
              onClick={async () => { 
                await setActiveChat(row.id); 
              } }
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell >{row.summary}</TableCell>
              <TableCell >{row.sentiment > -1 ? row.sentiment : "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>


          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};


const ScoutAccountDashboard = ({ dashboardDate, accountId, setParent }) => {
  const theme = useTheme();
  const isLgOrBelow = useMediaQuery(theme.breakpoints.down('xl'));

  const [state, setState] = useReducer(defaultReducer, {
    loading: false,
    groups: 0,
    conversations: 0,
    productsCount: [],
    productsList: [],
    sentiment: 0,
    messagesData: [],
    messagesColors: [],
    summaries: [],
  });
  useEffect(async () => {
    const d = await api.get(`api/enterprises/${enterprise.id}/scout_analytics/account/?date=${dashboardDate}&account_id=${accountId}`);
    if (d.status === 200) {
      setState({  
        groups: d.data.groups || 0,
        conversations: d.data.conversations|| 0,
        messagesData: d.data.messages_data || [],
        messagesColors: d.data.messages_colors || [],
        sentiment: d.data.sentiment || 0,
        productsCount: d.data.products_count || [],
        productsList: d.data.products_list || [],
        summaries: d.data.summaries || [],
      })
    } else if (d.status === 204) {
      console.log("No data available for the selected date.");
    } else {
      console.error("Error fetching dashboard data:", d.status, d.statusText);
    }

  }, [dashboardDate, accountId]);
  return (
    <Box 
      id="dash-body"
      sx={{
        ...(isLgOrBelow && {
          height: 'calc(100vh - 40px)',
          overflowY: 'auto',
          paddingRight: '4px',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#a1a1a1',
          },
        }),
      }}
    >
      <Grid container spacing={1} id="dash-grid">
        <Grid item xl={2} lg={12} md={12} sm={12} xs={12} id="grid-item">
          <GroupsAndConversationsCount conversations={state.conversations} groups={state.groups} />
        </Grid>

        <Grid item xl={4} lg={12} md={12} sm={12} xs={12} id="grid-item">
          <MessagesChart messagesData={state.messagesData} messagesColors={state.messagesColors} />
        </Grid>

        <Grid item xl={2} lg={12} md={12} sm={12} xs={12} id="grid-item">
          <SentimentSlider sentiment={state.sentiment} />
        </Grid>

        <Grid item xl={4} lg={12} md={12} sm={12} xs={12} id="grid-item">
          <ProductsChart productsCount={state.productsCount} productsList={state.productsList} />
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} id="grid-item">
          <SummariesTable summaries={state.summaries} setParent={setParent} accountId={accountId} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ScoutAccountDashboard;